import { findQuoterByApQuoteId } from 'api/feature/quoterApi';
import { useCotizador } from 'context/apiContext';
import { useAuth } from 'context/userContext';
import { useEffect } from 'react'

const usePopulateHook = () => {

    const { populateContext } = useCotizador()
    const { user } = useAuth()

    useEffect(() => {
        const { apQuoteId } = user;

        if (apQuoteId) {
            findQuoterByApQuoteId(apQuoteId)
                .then(quotation => {
                    const { data } = quotation || {};
                    const { inputData } = data || {};
                    const { contextData } = inputData || {};

                    if (contextData) {
                        populateContext(contextData);
                    }
                })
                .catch(error => {
                    console.error('Error fetching quotation:', error);
                });
        }
    }, [user])
};

export default usePopulateHook;
